export default function dateFormat(fecha) {
    let newDate = fecha
    //console.log(newDate.length)
    if (newDate === null || newDate === undefined || newDate.length === 0 || newDate === "" || newDate === " ") {
        newDate = ""
    }
    else {
        let day = fecha.toLocaleString('en-us', { day: 'numeric' })
        let month = fecha.toLocaleString('en-us', { month: 'numeric' })
        day = day.length === 1 ? '0' + day : day
        month = month.length === 1 ? '0' + month : month
        const year = fecha.toLocaleString('en-us', { year: 'numeric' })
        newDate = day + "-" + month + "-" + year
    }
    return newDate
}